import { render } from "./ModalMostrarResolucion.vue?vue&type=template&id=6ec5a1eb&scoped=true"
import script from "./ModalMostrarResolucion.vue?vue&type=script&lang=js"
export * from "./ModalMostrarResolucion.vue?vue&type=script&lang=js"

import "./ModalMostrarResolucion.vue?vue&type=style&index=0&id=6ec5a1eb&scoped=true&lang=css"
import "./ModalMostrarResolucion.vue?vue&type=style&index=1&id=6ec5a1eb&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec5a1eb"]])

export default __exports__